import { parse, isValid } from "date-fns"

export default {
  data: function() {
    return {
      emailRegex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      rules: {
          nonEmptyArray: (msg) => [
              (v) =>
                  (v !== null &&
                      v.length > 0 &&
                      v.every((i) => i !== void 0 && i !== null && i.trim() !== "")) ||
                  msg ||
                  "Champs requis",
          ],
          nonEmpty: (msg = "Champs requis") => [
              (v) => (v !== void 0 && v !== null && v !== "") || msg,
          ],
          nonEmptyTrim: (msg = "Champs requis") => [
              (v) => (v !== undefined && v !== null && String(v).trim() !== "") || msg,
          ],
          maxLength: (maxLength, msg) => [
              (v) => (v === null || v.length <= maxLength) || msg || "Limite depassée",
          ],
          number: (msg) => [
              ...this.rules.nonEmpty(msg),
              (v) => !isNaN(v) || "doit être un nombre",
          ],
          numberOrEmpty: (msg = "Format numérique requis") => [
              (v) => !isNaN(v) || msg,
          ],
          numberSup0: (msg) => [
                ...this.rules.nonEmpty(msg),
              (v) => v > 0 || "Doit être supérieur à 0"
          ],
          abs: (msg) => [
              ...this.rules.number(msg),
              (v) => v > 0 || msg || "doit être > 0",
          ],
          regex: (r, msg) => [(v) => r.test(v) || msg],
          email: (msg) => [
              ...this.rules.regex(this.emailRegex, msg || "Email valide requis"),
          ],
          emailOrEmpty: (msg = "Format de l'email incorrect") => [
              (v) => {
                  const s = String(v ?? "").trim()
                  return s === "" || this.emailRegex.test(s) || msg
              },
          ],
          emailArray: (msg) => [
              (v) =>
                  v.every((i) => this.emailRegex.test(i.trim())) ||
                  msg ||
                  "Email valide requis",
          ],
          time: (msg) => [
              (v) => {
                  let valid = true;
                  try {
                      const [hoursStr, minutesStr] = v.split(":");
                      const hours = parseInt(hoursStr);
                      const minutes = parseInt(minutesStr);

                      valid =
                          hoursStr.length == 2 &&
                          minutesStr.length == 2 &&
                          !Number.isNaN(hours) &&
                          !Number.isNaN(minutes) &&
                          hours >= 0 &&
                          hours <= 23 &&
                          minutes >= 0 &&
                          minutes <= 59;
                  } catch (e) {
                      valid = false;
                  }
                  return valid || msg || "Format hh:mm";
              },
          ],
          isValidFrDate: (msg = "Date invalide") => [
              (v) => {
                  const s = String(v ?? "").trim()
                  if (s === "") return true
                  const d = parse(s, "dd/MM/yyyy", new Date())
                  return isValid(d) || msg
              },
          ]
      },
    };
  },
};
